import axios from 'axios';
import Cookie from 'js-cookie';
import alertify from 'alertifyjs';
import config from '../../../config/index';
import routes from '../../../constants/routes';
import {
  WITHDRAW_FT_TIP_INVESTMENT,
  WITHDRAW_FT_TIP_INVESTMENT_ERROR,
  WITHDRAW_FT_TIP_INVESTMENT_LOADING,
  WITHDRAW_FT_TIP_INVESTMENT_ERROR_DELETE
} from '../../types';

const withdrawFixTipInvestmentSuccess = withdrawFixTip => ({
  type: WITHDRAW_FT_TIP_INVESTMENT,
  withdrawFixTip
});

const withdrawFixTipInvestmentLoading = () => ({
  type: WITHDRAW_FT_TIP_INVESTMENT_LOADING
});

const withdrawFixTipInvestmentError = error => ({
  type: WITHDRAW_FT_TIP_INVESTMENT_ERROR,
  error
});

export const deleteWithdrawFixTipInvestmentError = () => ({
  type: WITHDRAW_FT_TIP_INVESTMENT_ERROR_DELETE
});

const withdrawFixTipInvestment = withdrawalDetails => (dispatch) => {
  dispatch(withdrawFixTipInvestmentLoading());
  const token = Cookie.get('jwtToken');
  return axios.post(
    `${config.apiUrl}${routes.WITHDRAWFIXTIPINVESTMENT}`, withdrawalDetails, {
      headers: { Authorization: `Bearer ${token}` }
    }
  ).then((response) => {
    Cookie.remove('investObj');
    const { data } = response;
    if (data.isSuccessful) {
      dispatch(withdrawFixTipInvestmentSuccess(data.responseMessage));
      alertify
        .alert('You have succeeded in withdrawing from your Fix Tip Investment.', () => {
          alertify.success('OK');
        }).setHeader('<em style="color: green; font-size: 18px; font-weight: bold;"> Success!!! </em> ');
      window.location.href = '/invest-plans';
    } else {
      dispatch(withdrawFixTipInvestmentError(data.responseMessage));
    }
  }).catch((error) => {
    const { data } = error.response;
    dispatch(withdrawFixTipInvestmentLoading());
    dispatch(withdrawFixTipInvestmentError(data.responseMessage));
    throw error;
  });
};

export default withdrawFixTipInvestment;
